import { Amplify, Auth } from 'aws-amplify';
console.log(Amplify);
const generateTempUsername = () => {
  return 'u_' + Math.random().toString(36).substring(2, 11) + Date.now().toString(36);
};

// User Login
export async function login(email: string, password: string) {
  try {
    const user = await Auth.signIn(email, password);
    return user;
  } catch (error) {
    console.error('Error signing in', error);
    throw error; // Handle errors in your app
  }
}

// User Registration
export async function register(email: string, firstname: string, lastname: string, phone: string, password: string, role: string, acceptCommunications: boolean, orgId?: string, sponsorId?: string, jobFairId?: string) {
  try {
    const generatedUsername = generateTempUsername();
    localStorage.setItem('tempSignUpUsername', generatedUsername); // Save it for confirm

    const { user } = await Auth.signUp({
      username: generatedUsername,
      password,
      attributes: {
        email, // Required attribute
        given_name: firstname,
        family_name: lastname,
        phone_number: '+1' + phone.replace(/\D/g, ''),
        'custom:roles': role,
        'custom:smsConsent': acceptCommunications ? 'true' : 'false',
        'custom:organizationId': orgId,
        'custom:sponsorId': sponsorId,
        'custom:jobFairId': jobFairId,
      },
    });
    return user;
  } catch (error) {
    console.error('Error signing up', error);
    throw error; // Handle errors in your app
  }
}

export async function confirmRegistration(email: string, confirmationCode: string) {
  try {
    const tempUsername = localStorage.getItem('tempSignUpUsername')
    if (!tempUsername) {
      console.error('No tempSignUpUsername found in localstorage');
      return;
    }

    const result = await Auth.confirmSignUp(tempUsername, confirmationCode);

    // Cleanup
    localStorage.removeItem('tempSignUpUsername');
    return result;
  } catch (error) {
    console.error('Error confirming registration', error);
    throw error; // Handle errors in your app
  }
}

// Resend Confirmation Code
export async function resendConfirmationCode(email: string) {
  try {
    const tempUsername = localStorage.getItem('tempSignUpUsername');
    if (!tempUsername) {
      console.error('No tempSignUpUsername found in localstorage');
      return;
    }
    const result = await Auth.resendSignUp(tempUsername);
    return result;
  } catch (error) {
    console.error('Error resending confirmation code', error);
    throw error; // Handle errors in your app
  }
}

// Request Password Reset
export async function requestPassword(username: string) {
  try {
    const result = await Auth.forgotPassword(username);
    return result;
  } catch (error) {
    console.error('Error requesting password reset', error);
    throw error; // Handle errors in your app
  }
}

// Get Current Authenticated User
export async function getUserByToken() {
  try {
    const user = await Auth.currentAuthenticatedUser();
    return user;
  } catch (error) {
    console.error('Error fetching authenticated user', error);
    throw error; // Handle errors in your app
  }
}
